import UserBlock from "../../components/bodyBlocks/editaUsuario/EditaUsuario";

// eslint-disable-next-line react-refresh/only-export-components
const DatoUsuario = () => {

    return (
        <div>
            <UserBlock />
        </div>

    );
};

export default DatoUsuario;